import React from 'react';
import {useEffect, useState} from 'react';
import {hints} from '../../helpers/constants';
import {lampIcon} from '../../images/svgIcons';
import './styles.scss';
let hintsArray = hints();

const Hint = () => {
  const [index, setIndex] = useState(0);
  const [hint, setHint] = useState(hintsArray[0]);
  let interval: any;
  const changeInterval = () => {
    let a = 0;
    interval = setInterval(() => {
      if (a === 3) {
        hintsArray = hints();
        a = 0;
        return;
      }
      a = a + 1;
      setIndex(a);
    }, 5000);
  };
  const deleteInterval = () => {
    clearInterval(interval);
  };
  useEffect(() => {
    changeInterval();
    return () => {
      deleteInterval();
    };
  }, []);
  useEffect(() => {
    setHint(hintsArray[index]);
  }, [index]);
  return (
    <div className="bold text-center">
      <h5 className="mb-0">Pro tip {lampIcon}</h5>
      <span className="hints text-shadow">{hint}</span>
    </div>
  );
};
export default Hint;
